export const meta = { id: 'O23', slug: 'criar-curriculo', title: 'Como criar o Currículo da Formação', description: 'Organize Etapas, Componentes, ordem, obrigatoriedade e pré-requisitos.', profile: 'owner', category: 'formacoes', type: 'task', status: 'published', order: 530, keywords: ['currículo','formação','etapas','componentes','pré-requisitos'], previous: 'O22', next: 'O24', related: ['O24','O25','O28','O29'], updatedAt: '2026-08-17', appVersion: 'v1' }

# Como criar o Currículo da Formação

O currículo transforma o objetivo da Formação em uma sequência concreta de desenvolvimento.

<HelpImage pendingId="O23.1" alt="Currículo completo de uma Formação" />

<Steps>
  <Step title="Crie uma Etapa">Defina um momento coerente do desenvolvimento.</Step>
  <Step title="Adicione Componentes">Escolha as experiências que fazem parte da Etapa.</Step>
  <Step title="Configure cada Componente">Defina tipo, ordem, obrigatoriedade e demais opções disponíveis.</Step>
  <Step title="Adicione pré-requisitos quando necessários">Use dependências somente quando uma experiência realmente exigir outra antes.</Step>
  <Step title="Revise o percurso completo">Confirme se o currículo leva ao resultado esperado.</Step>
</Steps>

<Callout type="important">A estrutura visual do currículo também representa regras reais de execução, especialmente quando há obrigatoriedade e pré-requisitos.</Callout>
